import { dateFormat, timeFormat } from "../../../../../helpers/date/date";

export function getDateOnlyValue(value) {
  const dateValue = value?.$d || value;
  if (!dateValue) return null;

  if (dateValue instanceof Date) {
    return new Date(
      dateValue.getFullYear(),
      dateValue.getMonth(),
      dateValue.getDate(),
    );
  }

  if (typeof dateValue === "string") {
    const [day, month, year] = dateValue.split("/");
    if (!day || !month || !year) return null;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  return null;
}

export function getTimeMinutesValue(value) {
  const timeValue = value?.$d || value;
  if (!timeValue) return null;

  if (timeValue instanceof Date) {
    return timeValue.getHours() * 60 + timeValue.getMinutes();
  }

  if (typeof timeValue === "string") {
    const [hourMinute, meridiem] = timeValue.trim().split(" ");
    const [rawHour, rawMinute] = hourMinute.split(":");
    let hour = Number(rawHour);
    const minute = Number(rawMinute);

    if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
    if (meridiem === "PM" && hour !== 12) hour += 12;
    if (meridiem === "AM" && hour === 12) hour = 0;

    return hour * 60 + minute;
  }

  return null;
}

export function getDateTimeValue(dateValue, timeValue) {
  const date = getDateOnlyValue(dateValue);
  const minutes = getTimeMinutesValue(timeValue);

  if (!date || minutes === null) return null;

  const dateTime = new Date(date);
  dateTime.setHours(Math.floor(minutes / 60), minutes % 60, 0, 0);

  return dateTime;
}

export function formatDatePickerValue(value) {
  const dateValue = value?.$d || value;
  if (!dateValue) return "";

  if (dateValue instanceof Date) {
    return dateFormat(dateValue);
  }

  return dateValue;
}

export function formatTimePickerValue(value) {
  const timeValue = value?.$d || value;
  if (!timeValue) return "";

  if (timeValue instanceof Date) {
    return timeFormat(timeValue);
  }

  return timeValue;
}
